import React, { FC } from "react";
import { Box } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { media } from "@utils/media";
import { BackgroundProps } from ".";

export const CheckinBackdrop: FC<BackgroundProps> = ({
  color = "blue",
  left = "none",
  right = "none",
  top = "none",
  bottom = "none",
  height = "full",
  sx = undefined,
}) => {
  return (
    <Box
      zIndex={-1}
      pos="fixed"
      w="full"
      h={height}
      top={top}
      left={left}
      right={right}
      bottom={bottom}
      sx={{
        display: "block",
        [media.desktop]: {
          display: "none",
        },
        ...(sx ?? {}),
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        fill="none"
      >
        <motion.path
          d="M-270 1014.41C-197.35 946.632 401.089 273.106 421.77 159.451C478.835 -154.153 -183.147 135.375 -183.147 435.17C-183.147 592.195 442.452 592.195 442.452 592.195L367.672 1192L629 1092.8"
          fill="transparent"
          strokeWidth="48"
          stroke={color}
          strokeLinecap="square"
          strokeLinejoin="bevel"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{
            duration: 1,
            yoyo: Infinity,
            ease: "easeInOut",
          }}
        />
      </svg>
    </Box>
  );
};
